<template>
  <div v-show="showDrum">
    <img :src="imageSrc" class="drum3d" />
    <audio
      v-show="false"
      :src="audioSrc"
      controls
      preload="auto"
      ref="audio-effect"
    />
  </div>
</template>

<script>
import Util from '@/util'
import imageSrc from '@/assets/images/effects-menu/drum.gif'
import audioSrc from '@/assets/audio/drumroll.mp3'

export default {
  props: {
    close: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      imageSrc,
      audioSrc,
      showDrum: false,
    }
  },
  created() {
    this.preLoadAsset()
  },
  mounted() {
    const audioEffect = this.$refs['audio-effect']
    if (!audioEffect) return
    audioEffect.play().catch(() => {})
    audioEffect.addEventListener('play', () => {
      this.showDrum = true
    })
    audioEffect.addEventListener('ended', () => {
      this.close()
    })
  },
  destroyed() {
    const audioEffect = this.$refs['audio-effect']
    if (!audioEffect) return
    audioEffect.pause()
  },
  methods: {
    preLoadAsset() {
      Util.preloadImage({ url: imageSrc })
    },
  },
}
</script>
<style scoped lang="scss">
</style>
